import { render, staticRenderFns } from "./modalEditEditorials.vue?vue&type=template&id=7921c4dc&"
import script from "./modalEditEditorials.vue?vue&type=script&lang=js&"
export * from "./modalEditEditorials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports